import SearchView from "./search";
export default SearchView;
